import { render } from "./BusinessProducts.vue?vue&type=template&id=63a1e3d4"
import script from "./BusinessProducts.vue?vue&type=script&lang=js"
export * from "./BusinessProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__